// /* eslint-disable no-unused-vars */
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const API_URL = process.env.REACT_APP_API_URL;

// // Helper to get headers with token
// const getAuthHeaders = () => {
//   const token = localStorage.getItem('authToken');
//   return {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };
// };

// const superAdminId = localStorage.getItem('userid') || 1;

// // Fetch Customers
// export const fetchCustomers = createAsyncThunk(
//   'customers/fetchCustomers',
//   async ({ page = 1, limit = 10 }, thunkAPI) => {
//     try {
//       // const res = await axios.get(
//       //   `${API_URL}/customers?branchId=${localStorage.getItem("userId")}`,
//       //   getAuthHeaders()
//       // );
//        const res = await axios.get(
//         `${API_URL}/customers?branchId=${localStorage.getItem("userId")}&page=${page}&limit=${limit}`,
//         getAuthHeaders()
//       );
//       return res.data.data;
//     } catch (error) {
//       toast.error("Failed to fetch customers");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );





// // // Fetch Customers with Backend Pagination
// // export const fetchCustomers = createAsyncThunk(
// //   'customers/fetchCustomers',
// //   async ({ page = 1, limit = 10 }, thunkAPI) => {
// //     try {
// //       const res = await axios.get(
// //         `${API_URL}/customers?branchId=${localStorage.getItem("userId")}&page=${page}&limit=${limit}`,
// //         getAuthHeaders()
// //       );
// //       // Return full response (pagination info + data)
// //       return res.data.data;
// //     } catch (error) {
// //       toast.error("Failed to fetch customers");
// //       return thunkAPI.rejectWithValue(error.response?.data || error.message);
// //     }
// //   }
// // );


// // Update Customer
// export const updateCustomer = createAsyncThunk(
//   'customers/updateCustomer',
//   async ({ id, payload }, thunkAPI) => {
//     try {
//       const res = await axios.put(
//         `${API_URL}/update-customer/${id}`,
//         payload,
//         getAuthHeaders()
//       );
//       toast.success("Customer updated successfully");
//       thunkAPI.dispatch(fetchCustomers());
//       return { id, ...payload };
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Update failed");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Update PIN
// export const updateCustomerPin = createAsyncThunk(
//   'customers/updateCustomerPin',
//   async ({ id, oldPin, newPin, confirmPin }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${API_URL}/update-pin/${id}`,
//         { oldPin, newPin, confirmPin },
//         getAuthHeaders()
//       );
//       toast.success("PIN updated successfully");
//       return response.data;
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to update PIN");
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Update Password
// export const updateCustomerPassword = createAsyncThunk(
//   'customers/updateCustomerPassword',
//   async ({ id, oldPassword, newPassword, confirmPassword }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${API_URL}/update-password/${id}`,
//         { oldPassword, newPassword, confirmPassword },
//         getAuthHeaders()
//       );
//       toast.success("Password updated successfully");
//       return response.data;
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to update password");
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Delete Customer
// export const deleteCustomer = createAsyncThunk(
//   'customers/deleteCustomer',
//   async (id, thunkAPI) => {
//     try {
//       await axios.delete(`${API_URL}/delete-customer/${id}`, getAuthHeaders());
//       toast.success("Customer deleted successfully");
//       thunkAPI.dispatch(fetchCustomers());
//       return id;
//     } catch (error) {
//       toast.error("Failed to delete customer");
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Slice
// const customerSlice = createSlice({
//   name: 'customers',
//   initialState: {
//     customers: [],
//     loading: false,
//     error: null,
//     success: null,
//   },
//   reducers: {
//     clearMessages: (state) => {
//       state.error = null;
//       state.success = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCustomers.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchCustomers.fulfilled, (state, action) => {
//         state.loading = false;
//         state.customers = action.payload;
//       })
//       .addCase(fetchCustomers.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       .addCase(updateCustomer.fulfilled, (state, action) => {
//         state.success = 'Customer updated successfully';
//         const updated = action.payload;
//         state.customers = state.customers.map((c) =>
//           c.id === updated.id ? { ...c, ...updated } : c
//         );
//       })
//       .addCase(updateCustomer.rejected, (state, action) => {
//         state.error = action.payload;
//       })

//       .addCase(deleteCustomer.fulfilled, (state, action) => {
//         state.success = 'Customer deleted successfully';
//         state.customers = state.customers.filter(c => c.id !== action.payload);
//       })
//       .addCase(deleteCustomer.rejected, (state, action) => {
//         state.error = action.payload;
//       })

//       .addCase(updateCustomerPin.rejected, (state, action) => {
//         state.error = action.payload;
//       })
//       .addCase(updateCustomerPassword.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearMessages } = customerSlice.actions;
// export default customerSlice.reducer;



/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

// 🔹 Auth header helper
const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// ========================
// FETCH CUSTOMERS
// ========================
export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async ({ page = 1, limit = 10, superAdminId, userId }, thunkAPI) => {
    try {
      if (!superAdminId) {
        return thunkAPI.rejectWithValue("Super Admin ID missing");
      }

      const branchId = localStorage.getItem("userId");

      const params = new URLSearchParams({
        branchId,
        superAdminId,
        page,
        limit,
      });

      if (userId) {
        params.append("userId", userId);
      }

      const res = await axios.get(
        `${API_URL}/customers?${params.toString()}`,
        getAuthHeaders()
      );

      // console.log("customer",res.data)
      return res.data;
    } catch (error) {
      toast.error("Failed to fetch customers");
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

// ========================
// UPDATE CUSTOMER
// ========================
export const updateCustomer = createAsyncThunk(
  "customers/updateCustomer",
  async ({ id, payload }, thunkAPI) => {
    try {
      await axios.put(
        `${API_URL}/update-customer/${id}`,
        payload,
        getAuthHeaders()
      );

      toast.success("Customer updated successfully");

      const state = thunkAPI.getState().customerReport;
      const { currentPage, limit } = state.pagination;
      const superAdminId = thunkAPI.getState().userProfile.profile?.superAdminId;

      thunkAPI.dispatch(
        fetchCustomers({ page: currentPage, limit, superAdminId })
      );

      return { id, ...payload };
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

// ========================
// DELETE CUSTOMER
// ========================
export const deleteCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async (id, thunkAPI) => {
    try {
      await axios.delete(
        `${API_URL}/delete-customer/${id}`,
        getAuthHeaders()
      );

      toast.success("Customer deleted successfully");

      const state = thunkAPI.getState().customerReport;
      const { currentPage, limit } = state.pagination;
      const superAdminId = thunkAPI.getState().userProfile.profile?.superAdminId;

      thunkAPI.dispatch(
        fetchCustomers({ page: currentPage, limit, superAdminId })
      );

      return id;
    } catch (error) {
      toast.error("Failed to delete customer");
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

// ========================
// SLICE
// ========================
const customerSlice = createSlice({
  name: "customerReport",
  initialState: {
    customers: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
      limit: 10,
    },
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload?.data || [];
        state.pagination = {
          currentPage: action.payload?.currentPage || 1,
          totalPages: action.payload?.totalPages || 1,
          totalRecords: action.payload?.totalRecords || 0,
          limit:
            action.payload?.limit ??
            state.pagination.limit,
        };
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateCustomer.fulfilled, (state) => {
        state.success = "Customer updated successfully";
      })

      // DELETE
      .addCase(deleteCustomer.fulfilled, (state) => {
        state.success = "Customer deleted successfully";
      });
  },
});

export const { clearMessages } = customerSlice.actions;
export default customerSlice.reducer;

